// src/hooks/useImagesLoaded.js
import { useState, useEffect } from "react";

export default function useImagesLoaded(containerRef) {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!containerRef?.current) {
      setIsLoaded(true);
      return;
    }

    const images = Array.from(containerRef.current.querySelectorAll("img"));

    // No images on page — proceed immediately
    if (images.length === 0) {
      setIsLoaded(true);
      return;
    }

    let resolved = 0;
    const total = images.length;

    const resolve = () => {
      resolved += 1;
      if (resolved === total) setIsLoaded(true);
    };

    images.forEach((img) => {
      // Already loaded from cache
      if (img.complete && img.naturalHeight !== 0) {
        resolve();
      } else {
        img.addEventListener("load", resolve, { once: true });
        img.addEventListener("error", resolve, { once: true }); // don't block on broken images
      }
    });
  }, [containerRef]);

  return isLoaded;
}
